import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class SubscriberEmailService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getSubscriberMailData(email, date): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString())
      .set('date', date.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SUBSCRIBER_EMAIL.SUBSCRIBER_MAIL}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  EditSubscriberMailData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SUBSCRIBER_EMAIL.SUBSCRIBER_MAIL}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  SaveSubscriberMailData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SUBSCRIBER_EMAIL.SUBSCRIBER_MAIL}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
